<template>
  <router-view v-if="isRouterAlive" />
</template>

<script>
import "@/assets/styles/blueTheme.scss";
import "@/assets/styles/greenTheme.scss";
export default {
  // inject: ["reload"],
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true,
    };
  },

  // async created() {
  //   //页面初始化前需要先获取国家配置及语言包
  //   Promise.all([
  //     this.countryUtil.getCodeAsync(),
  //     loadLanguageAsync(lang),
  //   ]).then((arr) => {
  //     this.countryUtil.updateCode(arr[0]);
  //     this.inited = true;
  //   });
  //   this.countryUtil.setApp(this);
  // },

  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => (this.isRouterAlive = true));
    },
  },
};
</script>

<style>
html,
body,
#app {
  margin: 0;
  padding: 0;
  height: 100%;
}
</style>
